import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaChevronRight } from 'react-icons/fa';
import {setSidebarOpen} from '../../store/global'

export const OpenSidebar = props => {
  const { itemId, sidebarOpenOverride, onSidebarOpen } = props;

  const sidebar = useSelector(state => state.global.sidebar);
  const item = useSelector(state => state.items[itemId]);
  const dispatch = useDispatch()
  const isSidebarOpen =
    typeof sidebarOpenOverride === 'boolean' ? sidebarOpenOverride : sidebar.open;

  return (
      <div
        style={{ width: isSidebarOpen ? 0 : 'auto' }}
        className={`${
          isSidebarOpen ? 'hidden' : 'block px-1'
        } font-condensed text-xl flex gap-1 items-center`}
      >
        {item?.label}
        <div
          className='cursor-pointer opacity-100 transition hover:opacity-50'
          onClick={() => {
            if (typeof onSidebarOpen === 'function') {
              onSidebarOpen();
            } else {
              dispatch(setSidebarOpen(true));
            }
          }}
        >
          <FaChevronRight />
        </div>
      </div>
  );
};
